.fx{z-index:2;}